import axios from 'axios';
import Vue from 'vue';

/* eslint no-param-reassign: ["error"] */
const currentState = {
  user: JSON.parse(localStorage.getItem('user')) || null,
  status: '',
  token: localStorage.getItem('token') || '',
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, { token, user }) {
    state.status = 'success';
    state.token = token;
    state.user = user;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
  },
  auth_error(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.token = '';
    state.user = null;
    localStorage.removeItem('token');
  },
};

const actions = {
  async login({ commit, dispatch }, params) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/login`, params);
      commit('auth_success', {
        token: data.api_token,
        user: data,
      });
      dispatch('invoices/getInvoices', {}, { root: true });
    } catch (error) {
      commit('auth_error');
    }
  },
  async getUser({ commit }) {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/me`);
      commit('auth_success', {
        token: data.api_token,
        user: data,
      });
    } catch (error) {
      commit('auth_error');
    }
  },
  async setAutoAddToInvoice({ commit }, params) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/setAutoAddToInvoice`, {
        invoice_autoadd: params,
      });
      return data;
    } catch (error) {
      commit('auth_error');
    }
  },
};

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  getUser: state => state.user,
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
